class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.currentProductId = null;
    this.currentCartSignature = null;
    this.isRecommendationLoading = false;

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    this.querySelector('#CartDrawer-Overlay')
      .addEventListener('click', this.close.bind(this));

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {

    const cartLink = document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {

      event.preventDefault();

      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {

      if (event.code.toUpperCase() === 'SPACE') {

        event.preventDefault();

        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {

    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    this.loadCartRecommendations();

    const cartDrawerNote =
      this.querySelector('[id^="Details-"] summary');

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {

        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        trapFocus(
          containerToTrapFocusOn,
          focusElement
        );

      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {

    this.classList.remove('active');

    removeTrapFocus(this.activeElement);

    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {

    cartDrawerNote.setAttribute('role', 'button');

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    if (
      cartDrawerNote.nextElementSibling.getAttribute('id')
    ) {

      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {

        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget
            .closest('details')
            .hasAttribute('open')
        );
      }
    );

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState,close_drawer) {

    this.querySelector('.drawer__inner')
      .classList.contains('is-empty') &&
      this.querySelector('.drawer__inner')
        .classList.remove('is-empty');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML =
        this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
    });

    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')
        .addEventListener(
          'click',
          this.close.bind(this)
        );

      if(parsedState.close_drawer){
      }else{
        this.open();
      }
      
    });
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {

    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  loadCartRecommendations(forceReload = false) {

    if (this.isRecommendationLoading) return;

    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {

        const recommendationWrapper =
          this.querySelector('.related-product-body');

        if (recommendationWrapper != null){

          /* empty cart */
          if (!cart.items.length) {

            recommendationWrapper.innerHTML = '';

            return;
          }

          const cartSignature = cart.items
            .map(item => `${item.key}-${item.quantity}`)
            .join(',');

          if (
            !forceReload &&
            this.currentCartSignature === cartSignature
          ) {
            return;
          }

          this.currentCartSignature = cartSignature;

          const firstProductId =
            cart.items[0].product_id;

          this.currentProductId = firstProductId;

          this.isRecommendationLoading = true;

          fetch(
            `/recommendations/products?section_id=cart-drawer-recommendations&product_id=${firstProductId}&limit=8`
          )
          .then((response) => response.text())
          .then((html) => {

            recommendationWrapper.innerHTML = html;

            this.initCartRecommendationSlider();

            this.isRecommendationLoading = false;

          })
          .catch((error) => {

            console.error(error);

            this.isRecommendationLoading = false;
          });

        }else{

          const recommendationWrapper_wrap =
          this.querySelector('.related-product-body-wrap');

          if (!recommendationWrapper_wrap) return;
          this.initCartRecommendationSlider();

        }

      });
  }

  initCartRecommendationSlider() {

    const slider =
      this.querySelector('.related-product-list');

    if (!slider) return;

    if (
      slider.swiper &&
      !slider.swiper.destroyed
    ) {

      slider.swiper.destroy(true, true);
    }

    new Swiper(slider, {

      slidesPerView: 1.31,
      spaceBetween: 10,
      navigation: {
        nextEl: '.related-button-next',
        prevEl: '.related-button-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 1.26,
          spaceBetween: 10,
        }
      },
    });
  }
}

customElements.define(
  'cart-drawer',
  CartDrawer
);

class CartDrawerItems extends CartItems {

  getSectionsToRender() {

    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define(
  'cart-drawer-items',
  CartDrawerItems
);

/* =========================
   CART UPDATE EVENT
========================= */

subscribe(
  PUB_SUB_EVENTS.cartUpdate,
  () => {

    const cartDrawer =
      document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    cartDrawer.currentCartSignature = null;

    setTimeout(() => {

      cartDrawer.loadCartRecommendations(true);

    }, 300);
  }
);



document.addEventListener('click', async (e) => {
    const atcButton = e.target.closest('.related-product-atc');
    if (!atcButton) return;
    var variantId =atcButton.dataset.variant;
    if (!variantId) return;
    atcButton.classList.add('loading');

    try {

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      });

      await refreshCartDrawerSections();
    } catch (error) {
      console.error(error);
    } finally {
      atcButton.classList.remove('loading');
    }
  });


  document.addEventListener('click', async (e) => {
    const cardButton = e.target.closest('.card-atc-btn');
    if (!cardButton) return;
    var variantId = cardButton.dataset.variid;
    if (!variantId) return;
    cardButton.classList.add('loading');
    var close_drawer = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      const addedProduct = await response.json();
      if(cardButton.closest('.feat-card-product').querySelector('.cart-count .text-wrap') != null){
        cardButton.closest('.feat-card-product').querySelector('.cart-count .text-wrap').textContent = addedProduct.quantity;
      }

      var cartResponse = await fetch('/cart.js');
      var cartData = await cartResponse.json();

      if(cartData.item_count == 0){
        document.querySelector('cart-drawer').classList.add('is-empty');
      }else{
        document.querySelector('cart-drawer').classList.remove('is-empty');
      }

      await refreshCartDrawerSections(close_drawer);

    } catch (error) {
      console.log(error);
    } finally {
      cardButton.classList.remove('loading');
    }

  });



async function refreshCartDrawerSections(close_drawer) {

  try {

    const sectionsRes = await fetch(
      '/?sections=cart-drawer,cart-icon-bubble'
    );

    const sections = await sectionsRes.json();

    const cartDrawer =
      document.querySelector('cart-drawer');

    if (!cartDrawer) return;
    /* RENDER CART */
    cartDrawer.renderContents({
      id: Date.now(),
      sections: {
        'cart-drawer': sections['cart-drawer'],
        'cart-icon-bubble': sections['cart-icon-bubble']
      },
      close_drawer: close_drawer
    });

    /* RESET RECOMMENDATIONS */
    cartDrawer.currentCartSignature = null;

    setTimeout(() => {

      if (
        typeof cartDrawer.loadCartRecommendations === 'function'
      ) {

        cartDrawer.loadCartRecommendations(true);
      }

    }, 300);

  } catch (error) {

    console.error('Cart Refresh Error:', error);
  }
}



document.addEventListener('click', async (e) => {

  /* =========================
     APPLY DISCOUNT
  ========================= */
  if (e.target.closest('.discount-apply')) {

    const button = e.target.closest('.discount-apply');
    const wrapper = button.closest('.cart-discount');

    if (!wrapper) return;

    const input = wrapper.querySelector('.discount-input');
    const message = wrapper.querySelector('.discount-message');
    const code = input.value.trim();
    var entered_code = 0;
    
    if (!code) return;

    button.classList.add('loading');
    entered_code = code;

    try {

      /* ✅ CHECK CART FIRST */
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      if (!cart || cart.item_count === 0) {
        showMessage(message, 'Your cart is empty. Add items before applying a discount.');
        return;
      }

      /* APPLY DISCOUNT */
      await fetch(`${window.location.origin}/discount/${encodeURIComponent(code)}?redirect=/cart/`, {
        method: 'GET',
        credentials: "include"
      })
      .then(() => fetch(`${window.location.origin}/cart.json`, { method: "GET" }))
      .then(response => response.json())
      .then(cartData => {
        var discountTitles = cartData.items.map(item => item.discounts.map(discount => discount.title.toLowerCase())).flat().filter(title => title);

        if (discountTitles.includes(code.toLowerCase())) {
          localStorage.setItem('cart_discount_code', code);
          refreshCartDrawerSections2();
          
        }else{
          showMessage(message, 'Please enter a valid code.');
        }

      });

    } catch (error) {
      console.error('Discount Apply Error:', error);
      showMessage(message, 'Something went wrong. Try again.');
    } finally {
      button.classList.remove('loading');
    }
  }

  /* =========================
     REMOVE DISCOUNT
  ========================= */
  if (e.target.closest('.coupon-code-tag') || e.target.closest('.discount-message')) {

    const wrapper = document.querySelector('.cart-discount');
    if (!wrapper) return;

    const message = wrapper.querySelector('.discount-message');

    try {

      fetch(`${window.location.origin}/checkout?discount=CLEAR`).finally(() => {

      });

      localStorage.removeItem('cart_discount_code');

      await refreshCartDrawerSections2();
      clearDiscountUI(wrapper);
      
      if (message) {
        message.innerHTML = '';
        message.classList.remove('active');
      }

    } catch (error) {
      console.error('Discount Remove Error:', error);
    } finally {

      await fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['.drawer__footer' , 'cart-drawer-items'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      });

    }
  }
});


/* =========================
   HELPER: SHOW MESSAGE
========================= */
function showMessage(messageEl, text) {
  if (!messageEl) return;
  const wrap = messageEl.querySelector('.text-wrap');
  if (wrap) wrap.innerHTML = text;
  messageEl.classList.add('active');
}


/* =========================
   DISCOUNT UI RENDER
========================= */
function renderDiscountUI(code) {
  const wrapper = document.querySelector('.cart-discount');
  if (!wrapper) return;

  const appliedList = wrapper.querySelector('.discount-applied-list');
  if (!appliedList) return;

  appliedList.querySelector('span').innerHTML = code;
  appliedList.classList.add('active');
}


/* =========================
   CLEAR UI
========================= */
function clearDiscountUI(wrapper) {
  const appliedList = wrapper.querySelector('.discount-applied-list');
  const input = wrapper.querySelector('.discount-input');

  if (appliedList) {
    appliedList.querySelector('span').innerHTML = '';
    appliedList.classList.remove('active');
  }

  if (input) input.value = '';
}


/* =========================
   REFRESH CART DRAWER
========================= */
async function refreshCartDrawerSections2() {

  try {

    const [sectionsRes, cartRes] = await Promise.all([
      fetch('/?sections=cart-drawer,cart-icon-bubble'),
      fetch('/cart.js')
    ]);

    const sections = await sectionsRes.json();
    const cart = await cartRes.json();

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    /* RENDER CART */
    cartDrawer.renderContents({
      id: Date.now(),
      sections: {
        'cart-drawer': sections['cart-drawer'],
        'cart-icon-bubble': sections['cart-icon-bubble']
      }
    });

    /* RESET RECOMMENDATIONS */
    cartDrawer.currentCartSignature = null;

    setTimeout(() => {
      if (typeof cartDrawer.loadCartRecommendations === 'function') {
        cartDrawer.loadCartRecommendations(true);
      }
    }, 300);

    /* ✅ HANDLE DISCOUNT STATE */
    const savedCode = localStorage.getItem('cart_discount_code');

    if (cart.item_count === 0) {
      /* CLEAR EVERYTHING IF CART EMPTY */
      localStorage.removeItem('cart_discount_code');
      return;
    }

    if (savedCode) {

      setTimeout(() => {

        renderDiscountUI(savedCode);

        const message = document.querySelector('.discount-message');
        if (message) {
          const wrap = message.querySelector('.text-wrap');
          if (wrap) {
            wrap.innerHTML = `Coupon Code "${savedCode}" Applied.`;
          }
          message.classList.add('active');
        }

        const input = document.querySelector('.discount-input');
        if (input) input.value = savedCode;

      }, 350);
    }

  } catch (error) {
    console.error('Cart Refresh Error:', error);
  }
}


/* =========================
   RESTORE ON LOAD
========================= */
document.addEventListener('DOMContentLoaded', async () => {

  try {

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const savedCode = localStorage.getItem('cart_discount_code');

    if (!savedCode || cart.item_count === 0) {
      localStorage.removeItem('cart_discount_code');
      return;
    }

    renderDiscountUI(savedCode);

    const message = document.querySelector('.discount-message');
    if (message) {
      const wrap = message.querySelector('.text-wrap');
      if (wrap) {
        wrap.innerHTML = `Coupon Code "${savedCode}" Applied.`;
      }
      message.classList.add('active');
    }

    const input = document.querySelector('.discount-input');
    if (input) input.value = savedCode;

  } catch (error) {
    console.error('Init Discount Error:', error);
  }
});